/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum PayRunStatus {
  Draft = "draft",
  Finalized = "finalized",
}

export function instanceOfPayRunStatus(value: any): boolean {
  for (const key in PayRunStatus) {
    if (Object.prototype.hasOwnProperty.call(PayRunStatus, key)) {
      if (PayRunStatus[key as keyof typeof PayRunStatus] === value) {
        return true;
      }
    }
  }
  return false;
}

export function PayRunStatusFromJSON(json: any): PayRunStatus {
  return PayRunStatusFromJSONTyped(json, false);
}

export function PayRunStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PayRunStatus {
  return json as PayRunStatus;
}

export function PayRunStatusToJSON(value?: PayRunStatus | null): any {
  return value as any;
}

export function PayRunStatusToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): PayRunStatus {
  return value as PayRunStatus;
}
